// extracted by mini-css-extract-plugin
export default {"searchContainer":"Travellers_searchContainer__f1vZl","search":"Travellers_search__lgL5J","emptyContainer":"Travellers_emptyContainer__NdTSU","spinner":"Travellers_spinner__78t46"};